module.exports = __webpack_public_path__ + "static/rainbowbabyhwvest-abdc4fc51eecddd15062a3a855709232.jpeg";